<template>
    <!--TO SIMPLIFY USE OF ICONS, ALL TECHNIQUES FOR CALLING ICONS ARE COLLATED HERE-->
    <span @click="$emit('click')">
        <i v-if="name.startsWith('el-')" :class="name"/>
        <svgicon v-else :name="name" :color="color" :style="styleSvg"/>
    </span>
</template>

<script>
  export default {
    name: "DhIcon",
    props: {
      name: {
        type: String,
        default: "el-icon-warning"
      },
      color: {
        type: String,
        default: "inherit"
      },
      styleSvg: Object,
    }
  }
</script>

<style scoped>

</style>
